import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { addOrgDetailsFunc } from "../actions/commonActions";
import { userBrandInfo } from "../user/_userActions";
import {
  getAdminDefaultPath,
  isAdminCapabilityEnabled,
} from "../template/admin/sidebarVisibility";

// Resolve organisation flags once before deciding whether a typed admin URL is
// available. The sidebar consumes the same Redux value and the same capability
// helpers, keeping navigation visibility and direct-route access consistent.
const useAdminOrganisation = () => {
  const cached = useSelector((state) => state.common.orgDetails);
  const [state, setState] = useState({ loading: !cached, org: cached || null });

  useEffect(() => {
    let active = true;
    if (cached) {
      setState({ loading: false, org: cached });
      return () => {
        active = false;
      };
    }

    (async () => {
      try {
        const response = await userBrandInfo();
        const org = response?.data?.data?.orgBrandInfo || {};
        if (!active) return;
        if (response?.data?.status === 200) addOrgDetailsFunc(org);
        setState({ loading: false, org });
      } catch {
        if (active) setState({ loading: false, org: {} });
      }
    })();

    return () => {
      active = false;
    };
  }, [cached]);

  return cached
    ? { loading: false, org: cached }
    : state;
};

const RouteDecisionLoader = () => (
  <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
    <i className="fas fa-circle-notch fa-spin" aria-label="Loading"></i>
  </div>
);

export const AdminHomeRedirect = () => {
  const { loading, org } = useAdminOrganisation();
  if (loading) return <RouteDecisionLoader />;
  return <Navigate to={getAdminDefaultPath(org)} replace />;
};

export const AdminCapabilityGuard = ({ capability }) => {
  const { loading, org } = useAdminOrganisation();
  if (loading) return <RouteDecisionLoader />;
  if (!isAdminCapabilityEnabled(org, capability)) {
    return <Navigate to={getAdminDefaultPath(org)} replace />;
  }
  return <Outlet />;
};

